<div class="spinGral" id="loaderMicro" [ngStyle]="{'display': load.micro}">

  <div class="contCoin">
    <img src="./assets/icons/Loader-azul-BC.gif" alt="Cargando ofertas">
  </div>
  <div class="textSpin">Por favor espera un momento, {{ load.text == '' ? 'estamos cargando las mejores ofertas para
    ti.' : load.text }}</div>
</div>